import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import moment from 'moment-timezone';

@Directive({
    selector: '[daysBefore][formControlName][dayCount],[daysBefore][formControl][dayCount],[daysBefore][ngModel][dayCount]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DaysBeforeValidatorDirective),
            multi: true,
        },
    ],
})
export class DaysBeforeValidatorDirective implements Validator
{
    @Input()
    public daysBefore: {
        days: number,
        before: string
    };

    validate(thisControl: AbstractControl): { [key: string]: any } {
        const thisControlValue = thisControl.value;

        let thatControl: any = false;
        let thatControlValue = null;
        if (this.daysBefore.before === 'today') {
            thatControlValue = moment.utc();
        } else {
            thatControl = thisControl.root.get(this.daysBefore.before);
            if (thatControl) {
                thatControlValue = thatControl.value;
            }
        }

        if (moment.isMoment(thisControlValue) && moment.isMoment(thatControlValue)) {
            const comparisonDate = thatControlValue.clone().subtract(this.daysBefore.days, 'day');
            if (!thisControlValue.isSameOrBefore(comparisonDate, 'day')) {
                const dateInterval = this.daysBefore.days === 1 ? 'day' : 'days';
                return {
                    insufficientDayBuffer: 'Value must be at least ' + this.daysBefore.days + ' ' + dateInterval + ' before ' + this.daysBefore + '.',
                };
            }
        }

        return null;
    }
}
